import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Radio } from 'antd';
import { css } from '@emotion/core';

const AddOnsCheckboxes = ({ addOns, toggleAddOn }) => {
  return (
    <>
      {addOns.map(({ id, isSelected, cost, name }) => (
        <div
          key={id}
          css={css`
            margin-bottom: 5px;
          `}
        >
          <Radio
            css={css`
              white-space: pre-line;
            `}
            onChange={e => {
              toggleAddOn(e.target.checked, id);
            }}
            checked={isSelected}
          >
            {name}
            {` (+$${cost}/month)`}
          </Radio>
        </div>
      ))}
    </>
  );
};

AddOnsCheckboxes.propTypes = {
  addOns: PropTypes.array,
  toggleAddOn: PropTypes.func,
};

export default observer(AddOnsCheckboxes);
